import { render, staticRenderFns } from "./MyMemberships.vue?vue&type=template&id=5e5df855&scoped=true&"
import script from "./MyMemberships.vue?vue&type=script&lang=js&"
export * from "./MyMemberships.vue?vue&type=script&lang=js&"
import style0 from "./MyMemberships.vue?vue&type=style&index=0&id=5e5df855&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5df855",
  null
  
)

export default component.exports